import { Box, styled } from '@mui/material'
import balanceCardBg from 'assets/images/svg/wallet/balance-card-bg-new.svg'
import USDTSvgIcon from 'assets/images/svg/wallet/USDT-icon.svg'
import { CoinModel } from 'services/types/User'
import { useUsdPrice } from 'state/application/hooks'
import BigNumber from 'bignumber.js'
import { decimalFormat } from 'utils'
import { useMemo } from 'react'

const FontRobotoCondensed = styled(Box)`
  font-family: 'Poppins', 'Roboto Condensed', sans-serif;
  font-style: normal;
  font-weight: 500;
`
const MyBalanceCard = styled(Box)`
  width: 100%;
  height: 288px;
  background: url(${balanceCardBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 32px;
`
const BalanceAmount = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 103px;
`
const AmountInner = styled(Box)``
const USDTAmount = styled(FontRobotoCondensed)`
  font-size: 32px;
  line-height: 40px;
  color: #ffffff;
  margin-bottom: 8px;
  word-break: break-word;
  display: flex;
  > span {
    word-break: normal;
    display: inline-block;
    max-width: 165px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`
const USDAmount = styled(FontRobotoCondensed)`
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  word-break: break-word;
`

const AmountIcon = styled(Box)`
  margin-left: 10px;
  flex-shrink: 0;
  align-self: flex-start;
  width: 58px;
  height: 58px;
  background-image: url(${USDTSvgIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`

const BalanceInfo = styled(FontRobotoCondensed)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`
const UserName = styled(FontRobotoCondensed)`
  display: flex;
  align-items: center;
  font-size: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  span {
    margin-right: 4px;
    display: inline-block;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export default function MyBalanceComponent({ list }: { list: Array<CoinModel> }) {
  const price = useUsdPrice()
  const totalAmount = useMemo(() => {
    return list.reduce(
      (previousValue, currentValue) =>
        new BigNumber(previousValue)
          .plus(decimalFormat(currentValue.amount, currentValue.decimalNum, false, 10))
          .toString(),
      '0'
    )
  }, [list])
  return (
    <>
      <MyBalanceCard>
        <BalanceAmount>
          <AmountInner>
            <USDTAmount>
              <span>{new BigNumber(totalAmount).toFormat(2, 1)}</span>
              &nbsp; USDT
            </USDTAmount>
            <USDAmount>
              ≈&nbsp;<span>{new BigNumber(totalAmount).times(price).toFormat(2, 1)}</span>
              &nbsp; USD
            </USDAmount>
          </AmountInner>
          <AmountIcon></AmountIcon>
        </BalanceAmount>
        {list.map(el => (
          <BalanceInfo key={`balance-${el.chainId}`}>
            <UserName>
              <span>{el.chain}</span>
            </UserName>
            <UserName>
              <span>{decimalFormat(el.amount, el.decimalNum)}</span> {el.coin}
            </UserName>
          </BalanceInfo>
        ))}
      </MyBalanceCard>
    </>
  )
}
